import { RouteRecordRaw } from 'vue-router'

const Addresses = () =>
  import(/* webpackChunkName: "addresses-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'direcciones',
    name: 'addresses',
    component: Addresses,
    meta: {
      title: 'Direcciones',
      auth: {
        requiredPermission: 'addresses.view',
        requiredModule: 'addresses',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
